/* MARMOT: „Добави" от продуктовата карта (Порция 8.1 Б). Vanilla, defer.
   Клик „+" → /cart/add.js (1 бр.) БЕЗ напускане на страницата; после /cart.js
   за точния брой → обновява брояча в брандовия хедър (.marmot-header__count).
   Успех: бутонът показва „✓" + aria-live „Добавено", връща се на „+" след ~1,5с.
   Грешка: „↻" + title/aria „Опитай пак", бутонът остава активен за нов опит.
   НИКАКЪВ Lumia drawer/JS. */
(function () {
  'use strict';
  if (window.__marmotCartAddInit) return;
  window.__marmotCartAddInit = true;

  var REVERT_MS = 1500;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var liveEl = null;
  function announce(msg) {
    if (!liveEl) {
      liveEl = document.createElement('div');
      liveEl.className = 'marmot-sr-only';
      liveEl.setAttribute('aria-live', 'polite');
      liveEl.setAttribute('role', 'status');
      document.body.appendChild(liveEl);
    }
    // Смяна на текста гарантирано „изговаря" повторно.
    liveEl.textContent = '';
    window.setTimeout(function () { liveEl.textContent = msg; }, 30);
  }

  function updateCount(count) {
    var cart = document.querySelector('.marmot-header__icon--cart');
    if (!cart) return;
    var el = cart.querySelector('.marmot-header__count');
    if (count > 0) {
      if (!el) {
        el = document.createElement('span');
        el.className = 'marmot-header__count';
        cart.appendChild(el);
      }
      el.textContent = count;
    } else if (el) {
      el.parentNode.removeChild(el);
    }
  }

  function glyphOf(btn) {
    return btn.querySelector('.marmot-card__plus-glyph') || btn;
  }

  function reset(btn) {
    window.clearTimeout(btn._marmotTimer);
    btn._marmotTimer = window.setTimeout(function () {
      btn.classList.remove('is-added', 'is-error');
      btn.removeAttribute('title');
      glyphOf(btn).textContent = '+';
    }, REVERT_MS);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-marmot-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy === '1') return;

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.dataset.busy = '1';
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('add failed: ' + r.status); }
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.dataset.busy = '0';
        btn.classList.add('is-added');
        glyphOf(btn).textContent = '✓';
        announce('Добавено в количката');
        reset(btn);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.dataset.busy = '0';
        btn.classList.add('is-error');
        btn.setAttribute('title', 'Опитай пак');
        glyphOf(btn).textContent = '↻';
        announce('Възникна грешка. Опитай пак.');
        reset(btn);
      });
  }

  document.addEventListener('click', onClick);
})();
